/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPagingResponseOfAllotmentWithFareFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeAgGridClientQuery, serializePagingResponseOfAllotmentWithFare, type AgGridClientQuery, type PagingResponseOfAllotmentWithFare, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment/GetFinal
 */
export interface GetFinalRequestBuilder extends BaseRequestBuilder<GetFinalRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagingResponseOfAllotmentWithFare>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<PagingResponseOfAllotmentWithFare | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const GetFinalRequestBuilderUriTemplate = "{+baseurl}/Allotment/GetFinal";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetFinalRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: GetFinalRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagingResponseOfAllotmentWithFareFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAgGridClientQuery,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
